import { BrowserCacheLocation } from '@azure/msal-browser';

export const environment = {
  production: false,
  stage: 'dev',
  languageAssetsPath: 'assets/translations/',
  api: {
    backend: 'https://api.dev.workday-help.siemens.cloud/v1/',
    documents: 'https://assets.dev.workday-help.siemens.cloud/'
  },
  tracking: {
    endpointStage: 'dev',
    apiKey: '6fT8vpheoL6348l2us3sc6KWrXCxUsEdaxPALQmO',
    apiKeySE: 'UsFNi0zSQz2CtCLhJSHLQ7iYWgykxSEr2MhXcikn',
    apiKeySHS: 'C0zZcdFt3oa3A84iwKxN4696Wap4hhBD1VfLicoq'
  },
  trackingSuiteUrl: 'https://tracking.suites.siemens.cloud/tracking',
  msalConfig: {
    auth: {
      clientId: '34057572-95f7-4c1c-898f-a15970f740b9',
      authority: 'https://login.microsoftonline.com/38ae3bcd-9579-4fd4-adda-b42e1495d55a',
      redirectUri: window.location.origin,
      postLogoutRedirectUri: window.location.origin,
      navigateToLoginRequestUrl: true
    },
    cache: {
      cacheLocation: BrowserCacheLocation.SessionStorage,
      storeAuthStateInCookie: false
    },
    system: {
      allowPlatformBroker: false
    }
  },
  apiConfig: [
    {
      scopes: ['openid', 'profile', 'email', 'offline_access'],
      uri: 'https://graph.microsoft.com/v1.0'
    },
    {
      scopes: ['https://api.dev.workday-help.siemens.cloud/Api.ReadWrite'],
      uri: 'https://api.dev.workday-help.siemens.cloud/*'
    },
    {
      scopes: ['https://api.dev.ingestion.tracking.suites.siemens.cloud/TrackingRecord.Write'],
      uri: 'https://api.dev.ingestion.tracking.suites.siemens.cloud/*'
    }
  ]
};
